import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { cn } from '@/lib/utils';
import { getSubNavItems } from '@/constants/primary-navigation';

const SubNavBar: React.FC = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const items = getSubNavItems(location.pathname);

  if (!items || items.length === 0) return null;

  return (
    <div className="border-b border-gray-200 dark:border-gray-800 bg-white/50 dark:bg-gray-950/50 backdrop-blur-sm">
      <nav
        className="flex overflow-x-auto scrollbar-none px-4 gap-1"
        aria-label="Section navigation"
      >
        {items.map((item) => {
          const isActive = location.pathname === item.path;
          const Icon = item.icon;

          return (
            <button
              key={item.id}
              onClick={() => navigate(item.path)}
              className={cn(
                'flex items-center gap-1.5 px-3 py-2.5 text-sm font-medium whitespace-nowrap',
                'border-b-2 transition-all duration-200',
                'focus:outline-none focus-visible:ring-2 focus-visible:ring-primary-500',
                isActive
                  ? 'border-primary-600 dark:border-primary-400 text-primary-600 dark:text-primary-400'
                  : 'border-transparent text-gray-500 dark:text-gray-400 hover:text-gray-700 dark:hover:text-gray-200 hover:border-gray-300',
              )}
              aria-current={isActive ? 'page' : undefined}
            >
              {Icon && <Icon className="h-3.5 w-3.5" />}
              <span>{item.label}</span>
            </button>
          );
        })}
      </nav>
    </div>
  );
};

export default SubNavBar;
